import * as Configuration from '../../app.constants.js';
import { copyInputToClipboard } from '../parameters/quick-replies/joint-diagram/shared/helpers';
import DateUtils from 'src/app/shared/utils/date.utils';

PublicationListController.$inject = [
  '$scope',
  '$rootScope',
  'company',
  'PublicationFactory',
  'AlertingFactory',
  '$translate',
  'sites',
  '$state',
  'StrategiesFactory',
  'MediasFactory',
  'TopToolbarFactory',
  '$mdDialog',
  'ConfirmationFactory',
  '$timeout',
  'UserFactory',
];
export function PublicationListController(
  $scope,
  $rootScope,
  company,
  PublicationFactory,
  AlertingFactory,
  $translate,
  sites,
  $state,
  StrategiesFactory,
  MediasFactory,
  TopToolbarFactory,
  $mdDialog,
  ConfirmationFactory,
  $timeout,
  UserFactory,
) {
  init();
  $scope.setActiveStatus = setActiveStatus;
  $scope.filtersUpdated = filtersUpdated;
  $scope.clearSearch = clearSearch;
  $scope.typeSearch = typeSearch;
  $scope.buttonSearch = buttonSearch;
  $scope.company = company;
  $scope.publicationsByStatus = {};
  $scope.baseUrl = Configuration.constants.baseUrl;
  $scope.lastPageLoadedByStatus = {};
  $scope.loadMorePublications = loadMorePublications;
  $scope.reloadPublications = reloadPublications;
  $scope.goToInboxWithPublicationFilterSelected = goToInboxWithPublicationFilterSelected;
  $scope.editPublication = editPublication;
  $scope.retweetWith = retweetWith;
  $scope.reply = reply;
  $scope.likeWith = likeWith;
  $scope.copyPublicationLink = copyPublicationLink;
  $scope.deletePublication = deletePublication;
  $scope.duplicatePublication = duplicatePublication;
  $scope.openPictureInModal = openPictureInModal;
  $scope.openVideoInModal = openVideoInModal;
  $scope.pictureUrl = pictureUrl;
  $scope.videoUrl = videoUrl;
  $scope.shouldHideDatePicker = shouldHideDatePicker;
  $scope.displaySendError = displaySendError;
  $scope.getPublicationLinkLabel = getPublicationLinkLabel;
  $scope.capitalize = capitalize;
  $scope.canSeePublicationOnSocialMedia = canSeePublicationOnSocialMedia;

  const SEARCH_MIN_CHARS = 3;

  function loadMorePublications() {
    const loadingStatus = $scope.activeStatus;

    if ($scope.isLoading) return;
    $scope.isLoading = true;

    const PAGE_SIZE = 20;
    let pageToLoad;
    if ($scope.lastPageLoadedByStatus[loadingStatus] === undefined) {
      $scope.publicationsByStatus[loadingStatus] = [];
      pageToLoad = 0;
    } else {
      pageToLoad = $scope.lastPageLoadedByStatus[loadingStatus] + 1;
    }
    $scope.lastPageLoadedByStatus[loadingStatus] = pageToLoad;
    var filters = angular.copy($scope.filters);

    if (filters.searchInput?.length < SEARCH_MIN_CHARS) {
      delete filters.searchInput;
    }

    let dateRange = { from: null, to: null };
    // we want to ignore the dateRange filter for scheduled publications
    if (loadingStatus === 'scheduled') {
      filters.dateRange.from = null;
      filters.dateRange.to = null;
    } else {
      dateRange = getDateRangeInTimezone($scope.filters.dateRange);
    }

    PublicationFactory.getPublications($scope.company.id, loadingStatus, filters, dateRange, PAGE_SIZE, pageToLoad)
      .then((results) => {
        results.data.publications.forEach(publication => {
          _formatOptionalContent(publication);
          publication.hasOneChunkFailed = publication.chunks_send_status.some(chunk => chunk.status === 'failed')
        });

        $scope.publicationsByStatus[loadingStatus].push(...results.data.publications);

        if (loadingStatus === 'published') {
          // Commented because of new twitter API rate limite, TODO improve, perhaps on demand, depends on BE
          // updatePublicationsStats(results.data.publications);
        }

        // If we changed the tab while we were loading then load publications for the new tab
        if (loadingStatus !== $scope.activeStatus) {
          $scope.isLoading = false;
          loadMorePublications();
        }

      }, AlertingFactory.httpErrorHandler())
      .finally(() => ($scope.isLoading = false));
  }

  function _formatOptionalContent(publication) {
    if (publication.last_revision?.content?.length) {
      publication.last_revision.content = publication.last_revision.content.map(message => message ?? '');
    }
  }

  /**
   * Convert the date from date range picker in the timezone of the user.
   * Only for request, not display in picker.
   */
  function getDateRangeInTimezone(dateRange) {
    const { from, to } = dateRange;

    if (from && to) {
      const fromTime = DateUtils.createDate({
        year: from.getFullYear(),
        month: from.getMonth(),
        date: from.getDate(),
        hour: 0,
        minute: 0,
        second: 0,
        timezone: UserFactory.getLoggedUser().timezone,
      });

      const toTime = DateUtils.createDate({
        year: to.getFullYear(),
        month: to.getMonth(),
        date: to.getDate(),
        hour: 23,
        minute: 59,
        second: 59,
        timezone: UserFactory.getLoggedUser().timezone,
      });

      return { from: fromTime.toDate(), to: toTime.toDate() };
    }

    return { from: null, to: null };
  }

  function updatePublicationsStats(publications) {
    if (!$scope.tweetByPublicationId) {
      $scope.tweetByPublicationId = {};
    }
    if (!$scope.errorByPublicationId) {
      $scope.errorByPublicationId = {};
    }
    if (!$scope.twitterUserById) {
      $scope.twitterUserById = {};
    }

    PublicationFactory.getPublicationsTwitterStats(
      $scope.company.id,
      publications.map((p) => p['id'])
    ).then((response) => {
      $scope.tweetByPublicationId = {
        ...$scope.tweetByPublicationId,
        ...response.data.tweet_by_publication_id,
      };
      $scope.errorByPublicationId = {
        ...$scope.errorByPublicationId,
        ...response.data.error_by_publication_id,
      };
      $scope.twitterUserById = {
        ...$scope.twitterUserById,
        ...response.data.twitter_user_by_id,
      };
    }, AlertingFactory.httpErrorHandler());
  }

  function setActiveStatus(status) {
    $scope.activeStatus = status;
    $scope.activeStatusIndex = $scope.possibleStatuses.indexOf(status);
  }

  function reloadPublications() {
    // Delete already loaded publication and reload
    $scope.publicationsByStatus = {};
    $scope.lastPageLoadedByStatus = {};
    $scope.tweetByPublicationId = {};
    $scope.twitterUserById = {};
    loadMorePublications();
  }

  function filtersUpdated() {
    if (!angular.equals($scope.filters, $scope.savedFilters)) {
      $scope.savedFilters = angular.copy($scope.filters);

      reloadPublications();
    }
  }

  /**
   * Update filters if user type enter, or clear totally the input with backspace
   * (it avoids to type "enter" after "backspace", wich is strange for use) 
   */
  function typeSearch(event) {
    if (
      !$scope.isLoading &&
      ((event.keyCode === 13 && this.filters.searchInput?.length >= SEARCH_MIN_CHARS) || this.filters.searchInput === '')
    ) {
      this.filtersUpdated();
    }
  }


  function buttonSearch() {
    if (!$scope.isLoading && this.filters.searchInput?.length >= SEARCH_MIN_CHARS) {
      this.filtersUpdated();
    }
  }

  function clearSearch() {
    if (!$scope.isLoading) {
      this.filters.searchInput = '';
      this.filtersUpdated()
    }
  }

  function goToInboxWithPublicationFilterSelected(publication) {
    const strategy = StrategiesFactory.getStrategyFromType(publication.site.type);
    // new inbox not able to preselect an account, maybe TODO to when migrating publications page
    // ask PO OG if it was only the channel or directly the task
    // but the feature does not work anymore on twitter or facebook
    $state.go('auth.alcmeon.inbox.list.tasks', {
      companyId: company.id,
      queueId: strategy.getTaskTypeQueueId(publication.tasks_type),
      publicationFilterMessageId: publication.sent[0].message.id,
    });
  }

  function movePublicationToNewStatusTabAndSwitchTab(publication, doSwitchTab) {
    // First remove the publication from the old status list
    $scope.possibleStatuses.forEach((status) => {
      if (status in $scope.publicationsByStatus) {
        const publications = $scope.publicationsByStatus[status];
        const index = publications.findIndex((p) => p.id === publication.id);
        if (index !== -1) {
          publications.splice(index, 1);
        }
      }
    });

    // Then insert it in the new status list
    if ($scope.publicationsByStatus[publication.status]) {
      if (!$scope.publicationsByStatus[publication.status].some(x => x.id == publication.id)) {
        $scope.publicationsByStatus[publication.status].push(publication);
      }
    }

    // Switch to the new status tab
    if (doSwitchTab) {
      setActiveStatus(publication.status);
    }
  }

  function openPublicationEdition(event, publicationToEdit, isDuplication) {
    $mdDialog
      .show({
        controller: 'PublicationEditController',
        template: require('./publication-edit.html'),
        targetEvent: event,
        clickOutsideToClose: true,
        escapeToClose: false, // escape can be used to dismiss the @mention autocomplete popover
        focusOnOpen: false, // let the editor grab the focus
        locals: {
          dropdownItems: $scope.dropdownItems,
          companyId: company.id,
          sites: $scope.sites,
          publicationToEdit: publicationToEdit,
          isDuplication: isDuplication,
          parentPublication: event ? event.parentPublication : undefined
        },
      })
      .then((publication) => {
        if(publication) {
          movePublicationToNewStatusTabAndSwitchTab(publication, true);
        }
      });
  }

  function reply(event, publication) {
    addPublication({ ...event, parentPublication: publication });
  }

  function addPublication(event) {
    openPublicationEdition(event, null);
  }

  function editPublication(event, publication) {
    openPublicationEdition(event, publication);
  }

  function retweetWith(event, publication) {
    $mdDialog
      .show({
        controller: 'PublicationActionWithSiteSelectorController',
        template: require('./publication-action-with-site-selector.html'),
        clickOutsideToClose: false,
        targetEvent: event,
        resolve: {},
        locals: {
          sites: $scope.sites.filter(s => s.type_name === publication.site.type_name),
          title: $translate('publications/list/actions/retweet-with'),
        },
      })
      .then((retweetWithSiteId) => {
        PublicationFactory.retweet(company.id, publication.site.id, publication.id, retweetWithSiteId).then(
          (response) => {
            AlertingFactory.success('publications/list/post-successfully-retweeted');
            movePublicationToNewStatusTabAndSwitchTab(response.data.publication, true);
          },
          AlertingFactory.httpErrorHandler()
        );
      });
  }

  function likeWith(event, publication) {
    $mdDialog
      .show({
        controller: 'PublicationActionWithSiteSelectorController',
        template: require('./publication-action-with-site-selector.html'),
        clickOutsideToClose: false,
        targetEvent: event,
        resolve: {},
        locals: {
          sites: $scope.sites.filter(s => s.type_name === publication.site.type_name),
          title: $translate('publications/list/actions/like-with'),
        },
      })
      .then((likeWithSiteId) => {
        PublicationFactory.like(company.id, publication.site.id, publication.id, likeWithSiteId).then((response) => {
          AlertingFactory.success('publications/list/post-successfully-liked');
        }, AlertingFactory.httpErrorHandler());
      });
  }

  function copyPublicationLink(publication) {
    const publicationLink = publication.sent[0].url;

    const messages = {
      success: 'publications/list/actions/copy-link/success',
      error: 'publications/list/actions/copy-link/error',
    };

    copyInputToClipboard({ AlertingFactory }, publicationLink, messages);
  }

  function deletePublication(publication) {
    var okText = null;
    if ($scope.activeStatus === 'published') {
      var confirmationDeleteDialog = 'publications/list/confirm-delete-post';
    } else {
      var confirmationDeleteDialog = 'publications/list/confirm-delete-draft-or-scheduled-post';
      okText = 'publications/list/confirm-delete-draft-or-scheduled-post/ok-button';
    }
    ConfirmationFactory.materialConfirmDialog(confirmationDeleteDialog, {}, okText).then(function () {
      PublicationFactory.deletePublication(company.id, publication.site.id, publication.id).then((response) => {
        AlertingFactory.success('publications/list/post-successfully-deleted');
        movePublicationToNewStatusTabAndSwitchTab(response.data.publication, true);
      }, AlertingFactory.httpErrorHandler());
    });
  }

  function duplicatePublication(event, publication) {
    openPublicationEdition(event, publication, true);
  }

  function openPictureInModal(pictureId) {
    MediasFactory.pictureZoomMaterial(pictureUrl(pictureId), 'picture');
  }

  function openVideoInModal(videoId) {
    MediasFactory.pictureZoomMaterial(videoUrl(videoId), 'video');
  }

  function pictureUrl(pictureId) {
    return MediasFactory.pictureUrl(company.id, pictureId);
  }

  function videoUrl(videoId) {
    return MediasFactory.videoUrl(company.id, videoId);
  }

  function updatePublicationList(eventType, publicationEvent) {
    PublicationFactory.getPublication($scope.company.id, publicationEvent.site_id, publicationEvent.publication_id, $scope.filters)
      .then((results) => {
        if (results.data.publications.length) {
          results.data.publications.forEach(publication => _formatOptionalContent(publication));
          movePublicationToNewStatusTabAndSwitchTab(results.data.publications[0], false);
        }
        // Only refresh the publications stats if we're in the published tab
        if ($scope.activeStatusIndex === 0) {
          // Commented because of new twitter API rate limite, TODO improve, perhaps on demand, depends on BE
          // updatePublicationsStats(results.data.publications);
        }
      }, AlertingFactory.httpErrorHandler())
  }

  function shouldHideDatePicker() {
    return $scope.activeStatus === 'scheduled';
  }

  function displaySendError(chunk_send_status) {
    let details;
    if (UserFactory.canSeeActionErrorDetails()) {
      details = chunk_send_status.details;
    } else {
      details = ''
    }

    ConfirmationFactory.htmlMaterialConfirmDialog('publications/list/send-error', {
      'sendError': `${$translate.instant(chunk_send_status.key)} (${chunk_send_status.action_error_id})`,
      'details': details,
    });
  }

  function getPublicationLinkLabel(siteTypeName) {
    if (siteTypeName === 'twitter') {
      return $translate.instant('publications/list/actions/copy-tweet-link');
    } else {
      return $translate.instant('publications/list/actions/copy-post-link');
    }
  }

  function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function canSeePublicationOnSocialMedia(publication) {
    return $scope.activeStatus === 'published'
      || publication.site.type_name === 'facebook' && $scope.activeStatus === 'scheduled';
  }

  function init() {
    // When page loads, md-on-select="setActiveStatus(status)" of <md-tab> in the html
    // makes the "published" publications to be loaded automatically.
    $rootScope.$on('ws.publication', updatePublicationList);
    TopToolbarFactory.setButton('publications/list/new-publication', addPublication, $scope);

    const companySuffix = '-' + company.id;
    $scope.dateRangeKey = 'publication-dateRange' + companySuffix;
    $scope.dateRangeLabel = $translate.instant('publications/list/publication-date');
    $scope.accountKey = 'publication-field-account' + companySuffix;
    $scope.accountLabel = $translate.instant('publications/list/account_name');
    $scope.searchLabel = $translate.instant('publications/list/search-in-texts');

    $scope.filters = {
      dateRange: {
        from: null,
        to: null,
      },
      accounts: null,
      searchInput: null,
    };

    $scope.sites = sites.filter((s) => ['twitter', 'facebook'].includes(s.type_name));
    $scope.dropdownItems = PublicationFactory.buildDropdownItems($scope.sites);
    $scope.possibleStatuses = ['published', 'scheduled', 'draft', 'deleted'];

    // Save filters after the DOM has been loaded so that we save values set
    // by default by the date range picker
    $timeout(() => ($scope.savedFilters = angular.copy($scope.filters)), 0);
  }
}
